export default __webpack_public_path__ + "static/media/twitterBlack.56447a2d.svg";